<template lang="pug">
div
  #preloader(v-if="gameLaunching|| favListAction")
    #loader
  template(v-if="!pageLoading")
    .globby.s2
      template(v-if="visibleItems.length > 0")
        template(v-for="game in filteredList()")
          .gggl
            a(href="javascript:void(0)" @click='launchGame(game.game_code, game.game_name)')
              .iimg
                img.img-fluid(:src="'/new/img/game_icon/PG/'+game.game_code+'.png'")
            .prov
              img(:src="`/new/img/provider/pgsoft.png`")
            .fav.aaa
              i.fa-heart.pointer(:class="checkFav(game.game_code)" @click="favAction(game.game_platform,game.game_code,game.game_name,game.game_type,'/new/img/game_icon/PG/'+game.game_code+'.png')")
            .name {{game.game_name}}
    .load(v-if="visibleItems.length < listToDisplay.length" @click="loadMore")
      | Load more 
      span.loaded {{ visibleItems.length }} /
      | {{ listToDisplay.length }}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      temp:[],
      visibleItems: [], // Items currently displayed
      perPage: 15, // Number of items per load
      currentPage: 1,
      offList:[],
      // searchinput: "",
      gameOrder:[
        {id : "PG-SLOT-065"},
        {id : "PG-SLOT-050"},
        {id : "PG-SLOT-105"},
        {id : "PG-SLOT-058"},
        {id : "PG-SLOT-047"},
        {id : "PG-SLOT-111"},
        {id : "PG-SLOT-075"},
        {id : "PG-SLOT-106"},
        {id : "PG-SLOT-102"},
        {id : "PG-SLOT-041"},
        {id : "PG-SLOT-110"},
        {id : "PG-SLOT-101"},
        {id : "PG-SLOT-096"},
        {id : "PG-SLOT-078"},
        {id : "PG-SLOT-121"},
        {id : "PG-SLOT-120"},
        {id : "PG-SLOT-115"},
        {id : "PG-SLOT-104"},
        {id : "PG-SLOT-108"},
        {id : "PG-SLOT-076"},
        {id : "PG-SLOT-103"},
        {id : "PG-SLOT-112"},
        {id : "PG-SLOT-079"},
        {id : "PG-SLOT-117"},
        {id : "PG-SLOT-084"},
        {id : "PG-SLOT-095"},
        {id : "PG-SLOT-098"},
        {id : "PG-SLOT-090"},
        {id : "PG-SLOT-072"},
        {id : "PG-SLOT-055"},
        {id : "PG-SLOT-054"},
        {id : "PG-SLOT-070"},
        {id : "PG-SLOT-051"},
        {id : "PG-SLOT-052"},
        {id : "PG-SLOT-097"},
        {id : "PG-SLOT-083"},
        {id : "PG-SLOT-085"},
        {id : "PG-SLOT-109"},
        {id : "PG-SLOT-100"},
        {id : "PG-SLOT-038"},
        {id : "PG-SLOT-114"},
        {id : "PG-SLOT-099"},
        {id : "PG-SLOT-057"},
        {id : "PG-SLOT-030"},
        {id : "PG-SLOT-003"},
        {id : "PG-SLOT-063"},
        {id : "PG-SLOT-081"},
        {id : "PG-SLOT-093"},
        {id : "PG-SLOT-064"},
        {id : "PG-SLOT-043"},
        {id : "PG-SLOT-042"},
        {id : "PG-SLOT-060"},
        {id : "PG-SLOT-094"},
        {id : "PG-SLOT-092"},
        {id : "PG-SLOT-034"},
        {id : "PG-SLOT-074"},
        {id : "PG-SLOT-053"},
        {id : "PG-SLOT-116"},
        {id : "PG-SLOT-077"},
        {id : "PG-SLOT-069"},
        {id : "PG-SLOT-113"},
        {id : "PG-SLOT-061"},
        {id : "PG-SLOT-087"},
        {id : "PG-SLOT-068"},
        {id : "PG-SLOT-073"},
        {id : "PG-SLOT-059"},
        {id : "PG-SLOT-049"},
        {id : "PG-SLOT-119"},
        {id : "PG-SLOT-013"},
        {id : "PG-SLOT-091"},
        {id : "PG-SLOT-118"},
        {id : "PG-SLOT-086"},
        {id : "PG-SLOT-016"},
        {id : "PG-SLOT-107"},
        {id : "PG-SLOT-011"},
        {id : "PG-SLOT-005"},
        {id : "PG-SLOT-048"},
        {id : "PG-SLOT-023"},
        {id : "PG-SLOT-020"},
        {id : "PG-SLOT-062"},
        {id : "PG-SLOT-039"},
        {id : "PG-SLOT-089"},
        {id : "PG-SLOT-037"},
        {id : "PG-SLOT-071"},
        {id : "PG-SLOT-026"},
        {id : "PG-SLOT-006"},
        {id : "PG-SLOT-001"},
        {id : "PG-SLOT-066"},
        {id : "PG-SLOT-046"},
        {id : "PG-SLOT-015"},
        {id : "PG-SLOT-032"},
        {id : "PG-SLOT-018"},
        {id : "PG-SLOT-021"},
        {id : "PG-SLOT-035"},
        {id : "PG-SLOT-067"},
        {id : "PG-SLOT-028"},
        {id : "PG-SLOT-036"},
        {id : "PG-SLOT-040"},
        {id : "PG-SLOT-025"},
        {id : "PG-SLOT-044"},
        {id : "PG-SLOT-012"},
        {id : "PG-SLOT-024"},
        {id : "PG-SLOT-022"},
        {id : "PG-SLOT-017"},
        {id : "PG-SLOT-019"},
        {id : "PG-SLOT-045"},
        {id : "PG-SLOT-002"},
        {id : "PG-SLOT-009"},
      ],
      favListAction: false
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    },
    favList(){
			return this.$store.getters.getFavlist.filter((x)=>x.game_type === "SLOT")
		}
  },
  destroyed(){
    // window.removeEventListener('scroll', this.loadItems)
  },
  mounted(){
    // window.scroll(0,0)
    this.getProviderGameOfflist()
  },
  methods:{
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "PG"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.getGameList()
			}
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
			var url = config.getAwcList()
      this.$http.post(url, {
        "platform": "PG",
        "gametype": "SLOT"
      }).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              this.gameList = successResponse.data
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.game_code === obj2.game_id)
              )
              const reOrderList = this.gameOrder.map(x => x.id);
              const customSort = (item1, item2) => {
                const index1 = reOrderList.indexOf(item1.game_code);
                const index2 = reOrderList.indexOf(item2.game_code);

                if (index1 === -1 && index2 === -1) {
                  // If neither element is in order_array, maintain the original order.
                  return 0;
                } else if (index1 === -1) {
                  // If only arr1 is not in order_array, move it to the end.
                  return 1;
                } else if (index2 === -1) {
                  // If only arr2 is not in order_array, move it to the end.
                  return -1;
                }

                // Compare the indices in order_array.
                return index1 - index2;
              };
              this.listToDisplay.sort(customSort)
              this.visibleItems= this.listToDisplay.slice(0, this.perPage)
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    loadMore() {
      const start = this.currentPage * this.perPage;
      const newItems = this.listToDisplay.slice(start, start + this.perPage);
      this.visibleItems = [...this.visibleItems, ...newItems];
      this.currentPage++;
    },
    launchGame(game, name){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let lang_code = "en"
        let provider = "PG"
        let game_type = "SLOT"
        let game_name = name
        this.$store
          .dispatch("user/launchAwc", { player_id, auth_token,game_code, lang_code, provider, game_type, game_name })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {
              vm.gameLaunching = false        
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                    
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("/deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				$("#logModal").modal("show")
			}
    },
    filteredList(){
      return this.visibleItems.filter((game) =>
        game.game_name.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    },
    favAction(provider,game,name,type,img){
      if (this.sessionToken) {
        if(this.favList.some(obj=> obj.game_code === game)){
          this.removeFav(provider, game)
        }else{
          this.addFav(provider,game,name,type,img)
        }
      }else{
        $("#logModal").modal("show")
      }
    },
    addFav(provider,game,name,type,img){
      if (this.sessionToken) {
        this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let game_name = name
        let provider_code = provider
        let game_type = type
        let img_url = img
        this.$store
          .dispatch("user/addFav", { account_id, auth_token,game_code, game_name, provider_code, game_type, img_url })
          .then(response => {
            if (response.success == true) {
							// console.log(response)
              this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    removeFav(provider, game){
			if (this.sessionToken) {
        this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let provider_code = provider
        this.$store
          .dispatch("user/removeFav", { account_id, auth_token,game_code, provider_code })
          .then(response => {
            if (response.success == true) {
              // this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
		},
    checkFav(code){
      if(this.favList.some(obj=> obj.game_code === code)){
        return "fa-solid"
      }else{
        return "fa-regular"
      }
    },
    getFavlist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
							// console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
  }
}
</script>